import { z } from 'zod'

export const stereoMixSettingsSchema = z.object({
  leftToLeft: z.number().min(0).max(1).nullable().default(1),
  leftToRight: z.number().min(0).max(1).nullable().default(0),
  rightToLeft: z.number().min(0).max(1).nullable().default(0),
  rightToRight: z.number().min(0).max(1).nullable().default(1),
})
export type StereoMixSettings = z.infer<typeof stereoMixSettingsSchema>
